import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import { buildGlossaryTermSeo } from "@/lib/seo/glossaryJsonLd";
import GlossaryTermPage from "@/pages/GlossaryTerm";

const HUB = "/zh-cn/knowledge-center/glossary";

export const Route = createFileRoute("/zh-cn/knowledge-center/glossary/$slug")({
  head: ({ params }) => {
    const seo = buildGlossaryTermSeo("zh-cn", HUB, params.slug);
    return {
      ...buildRouteHead(`${HUB}/${params.slug}`, {
        title: seo.title,
        description: seo.description,
        noIndex: seo.noIndex,
      }),
      scripts: seo.scripts,
    };
  },
  component: GlossaryTermPage,
});
